import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, setToken } from "../api";
import { useAuth } from "../auth";
import { Footer } from "../App";

export default function AuthVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("This sign-in link is missing its token."); return; }
    api(`/auth/verify?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setToken(res.token);
        setUser(res.user);
        navigate("/", { replace: true });
      })
      .catch((e) => setError(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="frame">
      <header className="top"><div className="brand"><b>Oracle BFF</b></div></header>
      <div className="auth-wrap">
        <div className="auth-card" data-testid="auth-verify-card">
          {!error ? (
            <p className="sub" data-testid="auth-verify-loading">Signing you in…</p>
          ) : (
            <>
              <h1>That link didn't work</h1>
              <p className="sub" data-testid="auth-verify-error">{error}</p>
              <Link to="/optin" className="stamp-btn solid" data-testid="auth-verify-retry-link"
                style={{ display: "inline-block", textDecoration: "none" }}>
                Get a fresh link
              </Link>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
